import {TicketPerformance} from "@core/model/Ticket";
import {ApiBuilder} from "..";
import {Response, Ticket} from "../../model";

const addTicketMessage = (builder: ApiBuilder) =>
  builder.mutation<Response<Ticket>, {ticketId: string; text: string}>({
    query: request => ({
      url: `/api/ticket/message/${request.ticketId}`,
      method: "POST",
      body: request.text,
    }),
    invalidatesTags: t => [{type: "ticket", id: t?.data.id}],
  });

const updateTicketStatus = (builder: ApiBuilder) =>
  builder.mutation<Response<Ticket>, {ticketId: string; status: string}>({
    query: request => ({
      url: `/api/ticket/status/${request.ticketId}`,
      method: "POST",
      body: request.status,
    }),
    invalidatesTags: t => [{type: "ticket", id: t?.data.id}],
  });

const calculatePerformance = (builder: ApiBuilder) =>
  builder.query<
    TicketPerformance[],
    {from?: number; to?: number; groupByAssignee: boolean}
  >({
    query: ({from, to, groupByAssignee}) => {
      const params = new URLSearchParams();
      if (from) params.append("from", from.toString());
      if (to) params.append("to", to.toString());
      params.append("groupByAssignee", groupByAssignee ? "true" : "false");

      return {
        url: `/api/ticket/performance?${params.toString()}`,
        method: "GET",
      };
    },
    transformResponse: (response: Response<TicketPerformance[]>) =>
      response.data,
    providesTags: (result, _err, {from, to, groupByAssignee}) => {
      return result
        ? [
            {
              type: "measure",
              id: `performance-${groupByAssignee ? "grouped" : ""}-${from ?? ""}-${to ?? ""}`,
            },
          ]
        : [];
    },
  });

export {addTicketMessage, updateTicketStatus, calculatePerformance};
